import React from 'react'
import Svg from './Svg'
export const SvgSearch = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M.324 20.521a1.124 1.124 0 000 1.579l1.579 1.577a1.125 1.125 0 001.577 0l6.144-6.142c1.432.874 3.101 1.406 4.906 1.406 5.23 0 9.47-4.241 9.47-9.47 0-5.23-4.241-9.47-9.47-9.47-5.229 0-9.47 4.243-9.47 9.47 0 1.806.531 3.473 1.408 4.906L.324 20.521zM8.217 9.472a6.314 6.314 0 1112.628 0 6.314 6.314 0 01-12.628 0z" />
  </Svg>
))
SvgSearch.isIcon = true
export default SvgSearch
